import { CAMPAIGN_MAJ } from 'home/constants/RouteConstants'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import ReferencialPicturesApp from 'referencial/components/files/ReferencialPicturesApp'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'

const path = `/${CAMPAIGN_MAJ}/`

const CampaignPicturesApp = ({
    stationType,
}) => {
    const { id } = useParams()

    const {
        campaign,
    } = useSelector(store => ({
        campaign: store.CampaignReducer.campaign,
    }), shallowEqual)

    useTitle(() => [
        {
            title: i18n[stationType],
            href: `/${stationType}`,
        },
        {
            title: i18n.campaigns,
            href: `/${stationType}/campaign`,
        },
        {
            title: campaign.name || id,
            href: `/${stationType}/campaign/${id}/dashboard`,
        },
        {
            title: i18n.picturesAndDocuments,
            href: `/${stationType}/campaign/${id}/picture`,
        },
    ], [campaign, id, stationType])

    return (
        <ReferencialPicturesApp
            code={id}
            path={path}
            type={CAMPAIGN_MAJ}
        />
    )
}

CampaignPicturesApp.propTypes = {
    stationType: PropTypes.oneOf(['piezometry', 'pluviometry', 'hydrometry', 'installation', 'quality']),
}

export default CampaignPicturesApp
